export default "__VITE_ASSET__CDBcTYij__"